import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpv-attribute-liste',
  templateUrl: './attribute-liste.component.html',
  styleUrls: ['./attribute-liste.component.css']
})
export class AttributeListeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
